import { betoni_getString } from "src/data/betoni/BetoniFunctions";
import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_Teksti_Betoni({ subText, keikkaState }) {
  return (
    <GridKeikkaEditor_Teksti_Row title="Betoni ">
      <div>
        {keikkaState?.betoniAsiakasNimi} {keikkaState?.betoniSijaintiNimi}
      </div>
      {keikkaState?.betonit?.map((b) => (
        <div key={b.keikkaBetoniId}>
          <span style={{ color: "red" }}>
            {b.betoniVahvistettu === false && "Määrä/laatu ei vahvistettu !!  "}
          </span>
          <b>{subText(b.m3 + "m³ ")}</b>
          {subText(betoni_getString(b))}
        </div>
      ))}
    </GridKeikkaEditor_Teksti_Row>
  );
}

GridKeikkaEditor_Teksti_Betoni.propTypes = {
  subText: PropTypes.func.isRequired,
  keikkaState: PropTypes.any.isRequired,
};
